import { render, staticRenderFns } from "./SimpleLink.vue?vue&type=template&id=81cf12ca&"
import script from "./SimpleLink.vue?vue&type=script&lang=js&"
export * from "./SimpleLink.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports